"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Team = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Team = function Team() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.51 13.166c.49 0 .934.285 1.16.734l.044.1 1.233 3.707a.717.717 0 01.053.271.677.677 0 01-.578.683l-.077.005H19.6a2.26 2.26 0 00.193-.917l-.008-.186a2.291 2.291 0 00-.111-.543l-.032-.085-1.316-3.77h2.185zm-14.835 0l-1.316 3.769-.032.085a2.29 2.29 0 00-.111.543l-.008.186c0 .325.068.636.193.918l-2.746-.002-.077-.004A.677.677 0 011 17.978c0-.093.018-.185.053-.27l1.233-3.709.045-.099c.225-.449.67-.734 1.159-.734h2.185zm9.256-1.833c.685 0 1.308.38 1.623.98l.062.13 1.727 4.945a.917.917 0 01-.736 1.271l-.107.007h-11a.917.917 0 01-.843-1.278l1.727-4.944a1.833 1.833 0 011.685-1.111h5.862zM5.583 7.666a1.833 1.833 0 110 3.667 1.833 1.833 0 010-3.667zm12.834 0a1.833 1.833 0 110 3.667 1.833 1.833 0 010-3.667zM12 4a2.75 2.75 0 110 5.5A2.75 2.75 0 0112 4z",
    clipRule: "evenodd"
  });
};

exports.Team = Team;